import storage from "components/common/storage";

const LOCALE_STORAGE_KEY = "tiivii-locale";
const LOCALE_LOAD_STORAGE_KEY = "tiivii-locale-load";

const [fetchLocale, storeLocale] = storage(LOCALE_STORAGE_KEY, {});

const [fetchLocaleLoadBoolean, storeLocaleLoadBoolean] = storage(LOCALE_LOAD_STORAGE_KEY, {})

export default {fetchLocale, storeLocale, fetchLocaleLoadBoolean, storeLocaleLoadBoolean};
